import {Directive, ElementRef, Renderer2} from '@angular/core'
import marked from 'marked'

@Directive({
    selector: '[customMarkdown]'
})
export class CustomMarkdownDirective {

    constructor(private elementRef: ElementRef,
                private renderer: Renderer2)
    {}

    ngAfterViewInit() {
        if ( this.elementRef && this.renderer ) {
            this.executeMarkDown( this.elementRef, this.renderer )
        }
    }

    executeMarkDown( el, render ) {
        if ( el && render) {
            let markText = el.nativeElement.innerHTML;
            markText = markText.trim()
            if (markText && markText.length > 0) {
                const markdownHtml = marked(markText, {breaks: true, gfm: true});
                render.setProperty(el.nativeElement, 'innerHTML', markdownHtml);
            }
        }
    }
}
